import { PropsWithChildren, ReactNode, useState } from "react";
import { FOCUS_VISIBLE_RING_INSET } from "../../lib/a11yFocus";

type AccordionSectionProps = PropsWithChildren<{
    id: string;
    title: ReactNode;
    defaultOpen?: boolean;
}>

// Same card, toggle and +/- icon as the guidance accordions on CompanyPurchases.tsx.
// Content stays mounted while collapsed so unsaved edits survive a toggle.
function AccordionSection({ id, title, defaultOpen = false, children }: AccordionSectionProps) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="mt-4 rounded-lg bg-charcoal-600 p-4 text-white">
            <button
                type="button"
                aria-controls={id}
                aria-expanded={open}
                className={`flex items-center justify-between w-full text-left cursor-pointer px-1.5 ${FOCUS_VISIBLE_RING_INSET}`}
                onClick={() => setOpen(!open)}
            >
                <h2 className="text-lg">{title}</h2>
                <i className={`fa-solid ${open ? 'fa-minus' : 'fa-plus'} text-algae-300`} />
            </button>
            <div id={id} className={`${!open && 'hidden'} border-t border-charcoal-400 mt-4 pt-4`}>
                <div className="px-1.5">{children}</div>
            </div>
        </div>
    );
}

export default AccordionSection;
